<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="section1">
<h2 class="poem_title">Contents</h2>
<div class="pseudo_margin_1"></div><div class="pseudo_margin_1"></div>
<div class="pseudo_margin_1"></div>
<ul>
<li><span href="#/Title" title="Link target outside of Sample">Title page</span></li>
</ul>
<div class="pseudo_margin_1"></div>
<ol>
<li><a href="#/Chapter01" id="ch01">Chapter 1</a></li>
<li><a href="#/Chapter02" id="ch02">Chapter 2</a></li>
<li><a href="#/Chapter03" id="ch03">Chapter 3</a></li>
<li><span href="#/Chapter04" id="ch04" title="Link target outside of Sample">Chapter 4</span></li>
<li><span href="#/Chapter05" id="ch05" title="Link target outside of Sample">Chapter 5</span></li>
<li><span href="#/Chapter06" id="ch06" title="Link target outside of Sample">Chapter 6</span></li>
<li><span href="#/Chapter07" id="ch07" title="Link target outside of Sample">Chapter 7</span></li>
<li><span href="#/Chapter08" id="ch08" title="Link target outside of Sample">Chapter 8</span></li>
<li><span href="#/Chapter09" id="ch09" title="Link target outside of Sample">Chapter 9</span></li>
<li><span href="#/Chapter10" id="ch10" title="Link target outside of Sample">Chapter 10</span></li>
<li><span href="#/Chapter11" id="ch11" title="Link target outside of Sample">Chapter 11</span></li>
<li><span href="#/Chapter12" id="ch12" title="Link target outside of Sample">Chapter 12</span></li>
<li><span href="#/Chapter13" id="ch13" title="Link target outside of Sample">Chapter 13</span></li>
<li><span href="#/Chapter14" id="ch14" title="Link target outside of Sample">Chapter 14</span></li>
<li><span href="#/Chapter15" id="ch15" title="Link target outside of Sample">Chapter 15</span></li>
<li><span href="#/Chapter16" id="ch16" title="Link target outside of Sample">Chapter 16</span></li>
<li><span href="#/Chapter17" id="ch17" title="Link target outside of Sample">Chapter 17</span></li>
<li><span href="#/Chapter18" id="ch18" title="Link target outside of Sample">Chapter 18</span></li>
<li><span href="#/Chapter19" id="ch19" title="Link target outside of Sample">Chapter 19</span></li>
<li><span href="#/Chapter20" id="ch20" title="Link target outside of Sample">Chapter 20</span></li>
<li><span href="#/Chapter21" id="ch21" title="Link target outside of Sample">Chapter 21</span></li>
<li><span href="#/Chapter22" id="ch22" title="Link target outside of Sample">Chapter 22</span></li>
<li><span href="#/Chapter23" id="ch23" title="Link target outside of Sample">Chapter 23</span></li>
<li><span href="#/Chapter24" id="ch24" title="Link target outside of Sample">Chapter 24</span></li>
<li><span href="#/Chapter25" id="ch25" title="Link target outside of Sample">Chapter 25</span></li>
<li><span href="#/Chapter26" id="ch26" title="Link target outside of Sample">Chapter 26</span></li>
<li><span href="#/Chapter27" id="ch27" title="Link target outside of Sample">Chapter 27</span></li>
<li><span href="#/Chapter28" id="ch28" title="Link target outside of Sample">Chapter 28</span></li>
<li><span href="#/Chapter29" id="ch29" title="Link target outside of Sample">Chapter 29</span></li>
<li><span href="#/Chapter30" id="ch30" title="Link target outside of Sample">Chapter 30</span></li>
</ol>
<div class="pseudo_margin_1"></div>
<ul>
<li><span href="#/Glossary" id="gloss" title="Link target outside of Sample">Glossary</span></li>
<li><span href="#/Acknowledgments" id="ack" title="Link target outside of Sample">Acknowledgments</span></li>
<li><span href="#/Author" id="aut" title="Link target outside of Sample">About the Author</span></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?73532cc2